import * as z from "zod";

import { createUserOrgSettingsHooks } from "@/hooks/userOrgSettingsHooks";

export const PROOF_TRIGGERS = [
  "push",
  "opened",
  "agent_decided",
  "manual",
] as const;
export type ProofTrigger = (typeof PROOF_TRIGGERS)[number];

const UserProofSettings = z
  .object({
    proof_trigger: z.enum(PROOF_TRIGGERS),
    /** Kept in step with proof_trigger for backend pods that still read it. */
    proof_enabled: z.boolean().optional(),
  })
  // Old backend pods may still resolve Proof off through the boolean.
  .transform((settings) =>
    settings.proof_enabled === false
      ? { ...settings, proof_trigger: "manual" as const }
      : settings,
  );
export type UserProofSettings = z.infer<typeof UserProofSettings>;

const hooks = createUserOrgSettingsHooks<UserProofSettings>({
  resource: "user-proof-settings",
  errorMessage: "Failed to update Proof settings",
  parse: (data) => UserProofSettings.parse(data),
});

export const useUserProofSettings = hooks.useSettings;
export const useUpdateUserProofSettings = hooks.useUpdateSettings;
